import { createAction, props } from '@ngrx/store';
import { FileEntity } from './file.models';
import { IFile } from '@care-portals/api-interfaces';

export const loadFiles = createAction(
  '[File] Load Files',
  props<{ customerId: string; folder?: string }>()
);

export const loadFilesSuccess = createAction(
  '[File] Load Files Success',
  props<{ files: FileEntity[] }>()
);

export const loadFilesFailure = createAction(
  '[File] Load Files Failure',
  props<{ error: any }>()
);

export const getFile = createAction(
  '[File] Get File',
  props<{ customerId: string; fileName: string; folder?: string }>()
);

export const getFileSuccess = createAction(
  '[File] Get File Success',
  props<{ file: FileEntity }>()
);

export const getFileFailure = createAction(
  '[File] Get File Failure',
  props<{ error: any; fileName: string; folder?: string }>()
);

export const uploadFile = createAction(
  '[File] Upload File',
  props<{
    customerId: string;
    file: IFile;
    folder?: string;
    onSuccess?: (file: FileEntity) => void;
  }>()
);

export const uploadFileSuccess = createAction(
  '[File] Upload File Success',
  props<{ file: FileEntity }>()
);

export const uploadFileFailure = createAction(
  '[File] Upload File Failure',
  props<{ error: any }>()
);

export const deleteFile = createAction(
  '[File] Delete File',
  props<{
    customerId: string;
    fileName: string;
    folder?: string;
    onSuccess?: () => void;
    onFailure?: () => void;
  }>()
);

export const deleteFileSuccess = createAction(
  '[File] Delete File Success',
  props<{ fileName: string; folder?: string }>()
);

export const deleteFileFailure = createAction(
  '[File] Delete File Failure',
  props<{ error: any }>()
);
